import { makeStyles } from "@material-ui/core";

export const StatusSelectorStyle = makeStyles((theme) => ({

}))